import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { PageableTableComponent } from '../../../../shared/controls/pageable-table/pageable-table.component';

import { InitializerService } from '../../../../shared/services/initializer-service';
import { ErrorService } from '../../../../shared/services/error-service';

import { AuditErrorService, FilteredAuditErrorItem, PagingData } from '../../../../../service/proxy';

@Component({
    selector: 'app-audit-error',
    templateUrl: './audit-error.component.html',
    styleUrls: ['./audit-error.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
        PageableTableComponent,
    ],

    providers: [
        AuditErrorService,
    ]
})
export class AuditErrorComponent implements OnInit {
    public search: string = '';
    public paging: PagingData = new PagingData();
    public auditErrors: FilteredAuditErrorItem[] = [];
    public requestId: string = '';
    public auditError: any = {};

    constructor(
        private route: ActivatedRoute,
        private auditErrorService: AuditErrorService,
        private initializerService: InitializerService,
        private errorService: ErrorService)
        {
            this.paging = this.initializerService.createPagingData();
        }

    ngOnInit(): void {
        this.requestId = this.route.snapshot.paramMap.get('id') || '';

        if (this.requestId) {
            this.getAuditErrors(this.paging);
        }
    }

    refreshGridData(): void {
        this.paging = this.initializerService.createPagingData();
        this.getAuditErrors(this.paging);
    }

   getAuditErrors(pagingData: PagingData): void {
        if (this.requestId) {
            (this.auditErrorService.getFilteredAuditErrors as any)(
                this.search,
                pagingData.pageNo,
                pagingData.pageSize,
                pagingData.sortDirection,
                pagingData.sortColumn,
                this.requestId
            ).subscribe({
                next: (data: any) => {
                    this.paging = data.pagingData;
                    this.auditErrors = data.results || [];
                },
                error: (error: any) => {
                    if (error.status === 204) {
                        this.auditErrors = [];
                        this.paging = this.initializerService.createPagingData();
                    }
                    else {
                        this.errorService.handleError(error);
                    }
                }
            });
        }
    }

    getColumnMap() {
        return {
            requestId: 'Request Id',
            error: 'Error',
            createdAt: 'Created At',
        };
    }
}